import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
import TextField from '@material-ui/core/TextField/TextField';
import FormControl from '@material-ui/core/FormControl/FormControl';
import HttpAgent from '../../myapi';
import ButtonSubmit from '../../components/ButtonSubmit';
import { MsgError, MsgSuccess } from '../../components/Message';
import Grid from '@material-ui/core/Grid/Grid';
// import { Typography } from '@material-ui/core';

class NewPerson extends React.Component {
    state = {
        pname: '',
        city: '',
        bank: '',
        brnch: '',
        ifsc: '',
        acct: '',
        parent: null,
        procesing: true,
        failed: false,
        repeatError: false,
        success: false,
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    submit = e => {
        e.preventDefault();
        this.setState({ processing: true });

        const send = {
            action: 1,
            pname: this.state.pname,
            city: this.state.city,
            bank: this.state.bank,
            brnch: this.state.brnch,
            ifsc: this.state.ifsc,
            acct: this.state.acct
        };

        HttpAgent.post('/Persons/savePerson', send).then(res => {
            if (res === '@') {
                this.setState({
                    repeatError: true,
                    processing: false,
                });
            } else if (parseInt(res, 10) > 0) {
                //SUCCESS
                this.props.personAdded({ value: res, label: send.pname });
                this.setState({
                    success: true,
                    pname: '',
                    city: '',
                    processing: false,
                });
            } else {
                this.setState({
                    failed: true,
                    processing: false,
                });
            }
        });
    };

    render() {
        const {
            pname,
            city,
            bank,
            brnch,
            ifsc,
            acct,
            repeatError,
            processing,
        } = this.state;
        const formFilled = pname.length && city.length && bank.length && 
                brnch.length && ifsc.length && acct.length;
        return (
            <form style={{ width: '100%' }} noValidate>
                <Grid spacing={8} container>
                    <Grid sm={8} item>
                        <FormControl fullWidth error={repeatError}>
                            <TextField
                                value={pname}
                                onChange={this.handleChange('pname')}
                                margin="dense"
                                label="Name of Person*"
                                error={repeatError}
                            />
                            {repeatError && (
                                <FormHelperText>
                                    A Person with this name already exist.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid sm={4} item>
                        <FormControl fullWidth>
                            <TextField
                                value={city}
                                onChange={this.handleChange('city')}
                                margin="dense"
                                label="City*"
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid spacing={8} container>
                    <Grid sm={5} item>
                        <FormControl fullWidth error={repeatError}>
                            <TextField
                                value={bank}
                                onChange={this.handleChange('bank')}
                                margin="dense"
                                label="Bank Name*"
                            />
                        </FormControl>
                    </Grid>
                    <Grid sm={4} item>
                        <FormControl fullWidth>
                            <TextField
                                value={brnch}
                                onChange={this.handleChange('brnch')}
                                margin="dense"
                                label="Bank Branch*"
                            />
                        </FormControl>
                    </Grid>
                    <Grid sm={3} item>
                        <FormControl fullWidth>
                            <TextField
                                value={ifsc}
                                onChange={this.handleChange('ifsc')}
                                margin="dense"
                                label="IFSC Code*"
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid direction="row" alignItems="flex-end" container>
                    <Grid sm={8} item>
                        <FormControl fullWidth>
                            <TextField
                                value={acct}
                                onChange={this.handleChange('acct')}
                                margin="dense"
                                label="Bank Account Number*"
                            />
                        </FormControl>
                    </Grid>
                    <Grid style={{ marginLeft: 'auto' }} item>
                        <ButtonSubmit
                            label="Add Person"
                            processing={processing}
                            formFilled={formFilled}
                            submitFn={this.submit}
                        />
                    </Grid>
                </Grid>
                {this.state.failed && <MsgError msg="Process Failed" />}
                {this.state.success && <MsgSuccess msg="Person Added" />}
            </form>
        );
    }
}
export default NewPerson;
